module.exports = __webpack_public_path__ + "img/DFDFD6_58544E_81766A_989288-256px.8ce82327.png";